import { computed } from 'vue'

import { useRoute } from 'vue-router'

export function usePageNumberFromQuery() {
  const { query } = useRoute()
  const currentPage = computed(() => {
    const value = Array.isArray(query.page) ? query.page[0] : query.page

    return parseInt(value ?? '1', 10) || 1
  })

  return { currentPage }
}
